import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
Vue.use(ElementUI)
import 'element-ui/lib/theme-chalk/index.css';
import 'swiper/css/swiper.css';
import '@/assets/css/init.css';

import axios from './utils/axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
Vue.component('Treeselect',Treeselect);

import buttonCollection from '@/components/buttonCollection'
Vue.component('button-collection',buttonCollection);

import table_table from '@/components/table_table'
Vue.component('table_table',table_table);

import pagination from '@/components/pagination'
Vue.component('pagination',pagination);

import upload from '@/components/upload';
Vue.component('upload',upload);

import uploads from '@/components/uploads';
Vue.component('uploads',uploads);

import upload_import from '@/components/upload_import';
Vue.component('upload_import',upload_import);

// import tinymce from '@/components/tinymce/index.vue'
// Vue.component('tinymce', tinymce)

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import {removeByIndex,getTime,getDateTime,router_url,hasBtn,convertToTreeData,array_object,generateSku} from './utils/index'

import {get,post,put,export_blob,del} from '@/api/index'
Vue.prototype.hasBtn = hasBtn
Vue.prototype.removeByIndex = removeByIndex
Vue.prototype.convertToTreeData = convertToTreeData
Vue.prototype.generateSku = generateSku
Vue.prototype.array_object = array_object
Vue.prototype.getTime = getTime
Vue.prototype.getDateTime = getDateTime
Vue.prototype.router_url = router_url
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$export_blob = export_blob
Vue.prototype.$put = put
Vue.prototype.$del = del

import vuescroll from "vuescroll";
Vue.use(vuescroll, {
  ops: {
  	vuescroll:{wheelScrollDuration:200 },
		bar: {background: "#c1c1c1", keepShow: true},
		scrollPanel: {scrollingX: false, easing:'easeInQuad'}
	},
  name: 'vueScroll'
});

import store from './store'
import router from './permission' // 权限
new Vue({
	el: '#app',
	store,
	router,
	components: {
		App
	},
	template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js